/**
 * Decision Mode Type Definitions
 *
 * Types for the Decision Mode interface where users input a thesis
 * and see categorized evidence (supporting vs. contradicting) with
 * confidence scoring and knowledge gap identification.
 */

export enum RelationshipStance {
  SUPPORTING = 'supporting',
  CONTRADICTING = 'contradicting',
  NEUTRAL = 'neutral',
}

export interface EvidenceItem {
  nodeUid: string;
  title: string;
  snippet: string;
  stance: RelationshipStance;
  confidence: number;
  topics: string[];
  sourceType: string;
  createdAt?: string;
  reasoning?: string;
}

export interface KnowledgeGap {
  topic: string;
  description: string;
  suggestedSearch: string;
}

export interface DecisionAnalysis {
  thesis: string;
  summary?: string;
  supporting: EvidenceItem[];
  contradicting: EvidenceItem[];
  neutral: EvidenceItem[];
  knowledgeGaps: KnowledgeGap[];
  overallConfidence: number;
  topicCoverage: Record<string, number>;
  processingTimeMs: number;
}

export interface AnalyzeThesisRequest {
  thesis: string;
  filters?: {
    scope?: 'personal' | 'organization';
    minConfidence?: number;
    topicFilter?: string[];
    maxResults?: number;
  };
}

export interface DetectRelationshipsRequest {
  nodeUids: string[];
  scope?: 'personal' | 'organization';
}

export interface DetectedRelationship {
  sourceNodeUid: string;
  targetNodeUid: string;
  relationshipType: string;
  confidence: number;
  detectionMethod: string;
}

export interface RelationshipDetectionResult {
  relationships: DetectedRelationship[];
  processingTimeMs: number;
  nodeCount: number;
}
